<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-05-13 10:55:55
    Description : 关于
  -->
  <div class="main">
    <gaia-header :isShowUpload="false" />
    <div style="height: 100px"></div>
    <div class="page about-page">
      <el-tabs v-model="activeName">
        <el-tab-pane label="联系我们" name="0">
          <div style="height: 30px"></div>
          <p>
            Gaiamount 用心倾听您的声音，如果您在使用 Gaiamount
            时遇到任何问题，或者对我们有任何意见、建议，尽管告诉我们吧！
            <br />
            您可以在下方选择您觉得合适的方式与我们取得联系，我们将关注您的问题并尽快地给您回复。
          </p>
          <p>
            您可以把问题发送给我们的邮箱：<br />
            <span style="color: #4cc2ff">gaiamount@zunzheng.cn</span>
          </p>
          <p>或通过以下途径与我们联系并反馈您的问题：</p>
          <el-input
            v-model="form.name"
            prefix-icon="el-icon-user"
            placeholder="姓名"
            style="width: 600px"
          />
          <br />
          <el-input
            v-model="form.number"
            prefix-icon="el-icon-phone-outline"
            placeholder="联系电话"
            style="width: 600px"
          />
          <br />
          <el-input
            v-model="form.email"
            prefix-icon="el-icon-message"
            placeholder="联系邮箱"
            style="width: 600px"
          />
          <br />
          <el-input
            v-model="form.description"
            :rows="4"
            type="textarea"
            prefix-icon="el-icon-chat-line-square"
            placeholder="反馈内容及描述"
            style="width: 600px; margin-bottom: 20px"
          />
          <br />
          <el-button type="primary" @click="submit" round :loading="loading">
            反馈留言
          </el-button>
        </el-tab-pane>
        <el-tab-pane label="关于我们" name="1">
          <div class="about">
            <div style="height: 0px; position: relative; top: 40px">
              <img src="@/assets/images/gaia48/about-logo-1.png" />
            </div>
            <div style="padding: 50px 0 0 200px">
              <h2 style="padding-bottom: 20px; color: #717171">公司介绍</h2>
              <p>
                深圳市尊正数字视频有限公司成立于2004年，总部位于深圳市蛇口自贸区，涵盖线上影视流程及线下影视设备两大业务。
                Gaiamount（gaiamount.com）是其旗下一个集原创作品展示、素材在线交易、技术教程分享为一体的，聚合专业影视
                创作人的全流程线上技术交流平台。通过真正意义上的高清晰、高画质以及在线4K等强大功能来完美呈现原创者们的优秀
                创作，借助在线展示、分享、交流，及素材库、影视学院等助力专业的创作者们随时随地获取技术支持、创作灵感，甚至
                于随手创作，将自己最新的作品分享到平台，与众多圈内朋友一同交流、学习、进步！创作者主页、作品展示、在线交易、
                社交互动等专业自媒体属性与高质量的素材库和技术教程将使广大的专业用户及爱好者在工作与学习之外实现更多的创作
                价值与圈内交流，实现爱好到专业的跨越，形成完整的全流程影视创作！
              </p>
              <img src="@/assets/images/gaia48/about-img-2.png" />
              <img src="@/assets/images/gaia48/about-img-4.png" />
            </div>
            <div style="height: 0px; position: relative; top: 40px">
              <img src="@/assets/images/gaia48/about-logo-2.png" />
            </div>
            <div style="padding: 50px 0 0 200px">
              <h2 style="padding-bottom: 20px; color: #717171">
                Gaiamount <br />
                FILM SCIENCES AND ARTS <br />
                ACADEMY
              </h2>
              <p>
                深圳市尊正数字视频有限公司成立于2004年，总部位于深圳市蛇口自贸区，涵盖线上影视流程及线下影视设备两大业务。
                Gaiamount（gaiamount.com）是其旗下一个集原创作品展示、素材在线交易、技术教程分享为一体的，聚合专业影视
                创作人的全流程线上技术交流平台。通过真正意义上的高清晰、高画质以及在线4K等强大功能来完美呈现原创者们的优秀
                创作，借助在线展示、分享、交流，及素材库、影视学院等助力专业的创作者们随时随地获取技术支持、创作灵感，甚至
                于随手创作，将自己最新的作品分享到平台，与众多圈内朋友一同交流、学习、进步！创作者主页、作品展示、在线交易、
                社交互动等专业自媒体属性与高质量的素材库和技术教程将使广大的专业用户及爱好者在工作与学习之外实现更多的创作
                价值与圈内交流，实现爱好到专业的跨越，形成完整的全流程影视创作！
              </p>
              <img src="@/assets/images/gaia48/about-img-5.png" />
              <img src="@/assets/images/gaia48/about-img-1.png" />
              <img src="@/assets/images/gaia48/about-img-3.png" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="flex">
        <div class="item">
          <p style="line-height: 80px">电话：0755-86391800</p>
          <img src="@/assets/icon/call-icon.png" style="margin-right: 20px" />
          <div style="display: inline-block; color: #717171; font-size: 14px">
            <div>Gaiamount</div>
            <div>联系电话</div>
          </div>
        </div>
        <div class="item">
          <div style="margin: -10px 0 20px">
            <el-button
              type="primary"
              round
              style="margin-bottom: 10px"
              @click="
                jumpTo(
                  'http://sighttp.qq.com/authd?IDKEY=71b863d14c5e33e85652e5cd3b9e73ea45f5af34f7f29e20'
                )
              "
            >
              QQ在线交谈1
            </el-button>
            <br />
            <el-button
              type="primary"
              round
              style="margin-bottom: 10px"
              @click="
                jumpTo(
                  'http://sighttp.qq.com/authd?IDKEY=86a86754e43bcb2cf6a1fa632ba9a49df2af827938cbdb45'
                )
              "
            >
              QQ在线交谈2
            </el-button>
          </div>
          <img src="@/assets/icon/call-icon.png" style="margin-right: 20px" />
          <div style="display: inline-block; color: #717171; font-size: 14px">
            <div>Gaiamount</div>
            <div>联系QQ</div>
          </div>
        </div>
        <div class="item">
          <div style="margin-top: -42px">
            <img src="@/assets/images/wechat-scode.png" />
          </div>
          <img src="@/assets/icon/call-icon.png" style="margin-right: 20px" />
          <div style="display: inline-block; color: #717171; font-size: 14px">
            <div>Gaiamount</div>
            <div>官方微信</div>
          </div>
        </div>
        <div class="item">
          <div style="margin-top: -42px">
            <img src="@/assets/images/wechat-scode.png" />
          </div>
          <img src="@/assets/icon/call-icon.png" style="margin-right: 20px" />
          <div style="display: inline-block; color: #717171; font-size: 14px">
            <div>Gaiamount</div>
            <div>官方微博</div>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding-top: 40px">
        <img src="@/assets/images/zunzheng-address.png" />
        <el-divider />
        <p class="footer-text">
          通讯地址：深圳市南山区南海大道以西美年广场2栋6层 <br />
          邮政编码：518000
          <br />
        </p>
        <p
          class="footer-text"
          style="
            margin: 40px 0 20px;
            padding: 0 0 20px;
            font-size: 16px;
            font-weight: 700;
            color: #cccccc;
          "
        >
          Gaiamount
        </p>
      </div>
    </div>
    <gaia-footer />
  </div>
</template>

<script>
import gaiaFooter from "../components/gaia-footer/gaia-footer.vue";
import GaiaHeader from "../components/gaia-header/gaia-header.vue";
import { contactUs } from "@/api/works";
export default {
  components: { gaiaFooter, GaiaHeader },
  data() {
    return {
      activeName: "0",
      form: {
        name: "",
        number: "",
        email: "",
        description: "",
      },
      loading: false,
    };
  },
  created() {
    if (this.$route.query.type) {
      this.activeName = this.$route.query.type;
    }
  },
  methods: {
    submit() {
      if (
        this.form.name === "" ||
        this.form.number === "" ||
        this.form.email === "" ||
        this.form.description === ""
      ) {
        this.$message.error("不可提交空数据");
        return;
      }
      this.loading = true;
      contactUs(this.form)
        .then((res) => {
          this.$message.success("提交成功");
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error("提交失败");
          this.loading = false;
        });
    },
    jumpTo(url) {
      open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1400px;
  background: #f5f5f5;
}
.about-page {
  width: 1230px;
  min-height: 600px;
  padding: 10px 40px 0;
  margin: 0 auto 100px;
  background: #ffffff;
  .el-input {
    margin-bottom: 10px;
  }
}
p {
  font-size: 14px;
  margin-bottom: 30px;
  color: #717171;
}
.flex {
  display: flex;
  padding-top: 40px;
  .item {
    width: 25%;
    height: 200px;
    padding: 20px 0;
    margin: 10px 0;
    text-align: center;
    border-right: solid 1px #dbdbdb;
    box-sizing: border-box;
  }
  .item:last-child {
    border: none;
  }
}
.footer-text {
  color: #808080;
  font-size: 12px;
  font-weight: 100;
  font-style: italic;
}
.about {
  padding: 0px 60px;
}
</style>